<template>
  <div class="l-edit-dialog-box" style="padding-top:0">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="top" v-loading="loading">
      <!-- <el-divider content-position="left">基础信息</el-divider> -->
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="12">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form_data.username" autocomplete="off" placeholder="请输入用户名" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="12">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="form_data.mobile" autocomplete="off" placeholder="请输入手机号" :disabled="isInfo"></el-input>
             <template slot="prepend">+62</template>
          </el-form-item>
        </el-col> -->

        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入姓名" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="14">
          <el-form-item label="角色权限" prop="role_ids">
            <el-select v-model="form_data.role_ids" placeholder="请选择当前权限" :disabled="role_list.length==0 ||isInfo">
              <el-option v-for="item in role_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


          <el-col :span="12">
          <el-form-item label="归属公司" prop="company_id"> 
            <el-select v-model="form_data.company_id"  placeholder="请选管理公司" clearable   :disabled="company_list.length==0 ||isInfo">
              <el-option v-for="item in company_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

   

        <!-- 根据选着角色来判断-->
        <!-- <el-col :span="12">
          <el-form-item label="管理街道" prop="place_type_ids">
            <el-select v-model="form_data.place_type_ids" multiple placeholder="请选择街道(可多选)" clearable @change="changes" :disabled="place_type_list.length==0 ||isInfo ||role_highest_id.indexOf(form_data.role_ids)>=0|| form_data.role_ids == ''">
              <el-option v-for="item in place_type_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="14">
          <el-form-item label="管理场所类型" prop="place_type_ids">
            <el-select v-model="form_data.place_type_ids" multiple placeholder="请选择场所类型(可多选)" :disabled="place_type_list.length==0 ||isInfo ||role_highest_id.indexOf(form_data.role_ids)>=0 || form_data.role_ids == ''">
              <el-option v-for="item in place_type_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="管理街道" prop="street_ids">
            <el-select v-model="form_data.street_ids" multiple placeholder="请选择街道(可多选)" clearable @change="changes" :disabled="street_list.length==0 ||isInfo ||role_highest_id.indexOf(form_data.role_ids)>=0|| form_data.role_ids == ''">
              <el-option v-for="item in street_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="管理社区" prop="community_ids">
            <el-select v-model="form_data.community_ids" placeholder="请选择社区(可多选)" multiple :disabled="community_list.length==0 ||isInfo ||role_highest_id.indexOf(form_data.role_ids)>=0 || form_data.role_ids == ''">
              <el-option v-for="item in community_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
            <!-- <el-select v-model="form_data.community_ids" placeholder="请选择社区(可多选)" multiple :disabled="community_list.length==0 ||isInfo ||role_highest_id.indexOf(form_data.role_ids)>=0 || form_data.role_ids == '' ||  form_data.street_ids.indexOf(2) >=0">
              <el-option v-for="item in community_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select> -->
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <template v-if="!isInfo">
            <el-form-item label="密码" prop="pwd">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-input :type="form_data.pwd=='#none#'?'pwd':'text'" v-model="form_data.pwd" autocomplete="off"  placeholder="请输入登录密码">
                  </el-input>
                </el-col>
                <el-col :span="12">
                  <el-button type="primary" @click="randomWord">生成密码</el-button>
                  <el-button type="success" :disabled="!form_data.pwd||form_data.pwd=='#none#'" v-clipboard:copy="form_data.pwd" v-clipboard:success="copy">复制密码</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250" :disabled="isInfo" placeholder="请输入备注" show-word-limit></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="状态" prop="state">
            <el-switch v-model="form_data.state" :active-value="1" :inactive-value="0" :disabled="isInfo" active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import Vue from 'vue';
import { randomWord } from "@/utils/Fuc";
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
export default {
  name: "l-user-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
    isInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false, //页面是否加载中

      show_org_id_select: false,

      // org_tree: [],
      role_list: [],
      community_list: [],
      place_type_list: [],
      role_highest_id: [],
      street_list: [],
      company_list:[],
      defaultProps: {
        children: "children",
        label: "name",
      },
      //表单数据
      form_data: {
        name: "",
        state: 1,
        pwd: "",
        re_pwd: "",
        remark: "",
        community_ids: [],
        place_type_ids: [],
        street_ids: [],
        role_ids: "",
        y_role_ids: "",
        username: "",
        company_id:"",
      },
      //表单验证规则
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "change",
          },
        ],
        role_ids: [
          {
            required: true,
            message: "请选择职位",
            trigger: "change",
          },
        ],

        pwd: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "change",
          },
        ],

        state: [
          {
            type: "number",
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],


      },
      //提交按钮是否显示加载中
      submitting: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    changes() {
      this.$_invoke("adminUser_streetGetCommunity", {
        pid_ids: this.form_data.street_ids
      }).then((ret) => {
        // console.log(ret)
        this.community_list = ret.community_list;
      })
        .finally(() => {
          this.loading = false;
        });
    },

     changes_street() {
      this.$_invoke("adminUser_streetGetCommunity", {
        pid_ids: this.form_data.street_ids
      }).then((ret) => {
        // console.log(ret)
        this.community_list = ret.community_list;
      })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取数据
    getData() {
      this.loading = true;
      if (this.hasId) {
        this.$_invoke("adminUser_getUpdateData", {
          id: this.$props.id,
          // pid_ids: this.form_data.street_ids
        })
          .then((ret) => {
            // console.log(ret)
            this.community_list = ret.community_list;
            this.place_type_list = ret.place_type_list;
            this.street_list = ret.street_list;
            this.role_highest_id = ret.role_highest_id;
            this.role_list = ret.role_list;
            this.form_data = ret.data;
             this.company_list = ret.company_list;
            //  this.$nextTick(() => {
            //   //需要上去的数据

            //   ret.data.role_ids = ret.data.role_ids[0];
            //   this.form_data = ret.data;
            //   this.form_data.y_role_ids = ret.data.role_ids;

            // });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$_invoke("adminUser_getAddData", {
          pid_ids: this.form_data.street_ids
        })
          .then((ret) => {
            // console.log(ret)
            this.role_list = ret.role_list;
            this.community_list = ret.community_list;
            this.role_highest_id = ret.role_highest_id;
            this.street_list = ret.street_list;
            this.place_type_list = ret.place_type_list;
            this.company_list = ret.company_list;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },


    //生成随机密码
    randomWord() {
      this.form_data.pwd = randomWord(true, 6, 6);
    },

    //点击复制链接
    copy(e) {
       console.log(e.text);
      this.$_msg.success("复制成功");
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {
            //添加
            this.form_data.mobile = this.form_data.username;
            this.$_invoke("adminUser_save", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.form_data.id = this.$props.id;
            this.form_data.mobile = this.form_data.username;
            this.$_invoke("adminUser_update", this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>